import styled from "styled-components";
import { Body, BodyLarge, spacing, color } from "@conserveit/blocks";

export const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Segment = styled.div`
  display: inline-flex;
  align-items: center;
`;
export const Left = styled(Segment)`
  justify-content: flex-start;
`;

export const Right = styled(Segment)`
  justify-content: flex-end;
`;

export const IconWrapper = styled(Segment)`
  margin: ${spacing.tight};
`;

export const TodayCountWrapper = styled(Body)`
  color: ${color.theme.typography.subdued};
`;

export const SubduedBodyLarge = styled(BodyLarge)`
  color: ${color.theme.typography.subdued};
`;
